export default {"src":"/_next/static/media/MRK.4ba1d017.svg","height":18,"width":18};